// src/utils/phone.js
// Aceleași reguli ca în core/phones.py.

const digitsOf = (value) => String(value ?? "").replace(/\D/g, "");

/** Numărul fără separatori și fără prefix: 0722 123 456 și +40722123456 au aceeași cheie. */
export const phoneKey = (value) => digitsOf(value).replace(/^(0040|00|40(?=\d{9}$)|0)/, "");

/** Spune dacă textul căutat, scris ca număr de telefon, se potrivește cu numărul salvat. */
export function phoneMatchesSearch(phone, term) {
  const text = String(term ?? "").trim();
  const digits = digitsOf(text);
  const stored = digitsOf(phone);
  if (!digits || !stored || !/^[\d\s+().\-/]+$/.test(text)) return false;
  if (stored.includes(digits)) return true;

  const start = digits.replace(/^(0040|00|40|0)/, "");
  return start.length >= 2 && phoneKey(stored).startsWith(start);
}
